// extracted by mini-css-extract-plugin
module.exports = {"chart_start_color":"#7a7afc","main_color":"#3d578d"};